import { render } from "./KTDatatable.vue?vue&type=template&id=4e3a1749&ts=true"
import script from "./KTDatatable.vue?vue&type=script&lang=ts"
export * from "./KTDatatable.vue?vue&type=script&lang=ts"

import "./KTDatatable.vue?vue&type=style&index=0&id=4e3a1749&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__